
export default theme => {
  const dividerStyle = `1px solid ${theme.palette.divider}`
  const dividerTop = { borderTop: dividerStyle };
  const dividerBottom = { borderBottom: dividerStyle };

  return {
    paper: {
      borderRadius: theme.typography.pxToRem(10),
      backgroundColor: theme.palette.background.paper,
    },
  
    title: {
      fontSize: theme.typography.pxToRem(18),
      fontWeight: theme.typography.fontWeightMedium,
    },
  
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey.eccoGrey,
    },
    
    actions: {
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      border: 'none !important',
      '& > :not(:first-child)': {
        marginLeft: 0,
      },
    },
  
    button: {
      maxWidth: 223,
      width: '48%',
      paddingTop: 10,
      paddingBottom: 10,
      fontSize: theme.typography.pxToRem(14),
      [theme.breakpoints.down(426)]: {
        fontSize: theme.typography.pxToRem(12),
      },
      [theme.breakpoints.down(376)]: {
        width: '70%'
      },
    },

    dividersHeader: {
      '& .MuiDialogTitle-root': { ...dividerBottom },
    },
  
    dividersBody: {
      '& .MuiDialogContent-root': { ...dividerTop, ...dividerBottom }
    },
  
    dividersActions: {
      '& .MuiDialogActions-root': { ...dividerTop }
    },
  }
}